import type {
  IconDefinition as CoreIconDefinition,
  IconProp,
  SizeProp,
} from "@fortawesome/fontawesome-svg-core";
import type { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { CSSProperties } from "react";

interface IIcon {
  icon: CoreIconDefinition | IconDefinition | IconProp;
  className?: string;
  size?: SizeProp;
  id?: string;
  onClick?: () => void;
  style?: CSSProperties;
  inverse?: boolean;
  transform?: string;
}

const Icon: React.FC<IIcon> = ({
  icon,
  className,
  size,
  id,
  style,
  onClick,
  inverse = false,
  transform,
}) => {
  return (
    <FontAwesomeIcon
      icon={icon as IconProp}
      id={id}
      data-testid={id}
      className={className}
      size={size}
      style={style}
      onClick={onClick}
      inverse={inverse}
      transform={transform}
    />
  );
};

export default Icon;
